import { BrowserRouter } from 'react-router';
import { AppStateProvider } from './context/AppStateProvider';
import { AudioPlayerProvider, useAudioPlayer } from './context/AudioPlayerProvider';
import { VideoPlayerProvider } from './context/VideoPlayerProvider';
import { ShellHeader } from './components/ShellHeader/ShellHeader';
import { ShellBottomNav } from './components/ShellBottomNav/ShellBottomNav';
import { AudioPlayerBar } from './components/AudioPlayerBar/AudioPlayerBar';
import { VideoPlayerPanel } from './components/VideoPlayerPanel/VideoPlayerPanel';
import { BottomSheet } from './components/BottomSheet/BottomSheet';
import { AppRoutes } from './routes';
import './index.css';

function AppShell() {
  const { current } = useAudioPlayer();

  return (
    <div className={current ? 'app-shell app-shell--playing' : 'app-shell'}>
      <ShellHeader />
      <div className="app-shell__main">
        <AppRoutes />
      </div>
      <div className="app-shell__bottom">
        <AudioPlayerBar />
        <ShellBottomNav />
      </div>
      <BottomSheet />
      <VideoPlayerPanel />
    </div>
  );
}

export function App() {
  return (
    <AppStateProvider>
      <AudioPlayerProvider>
        <VideoPlayerProvider>
          <BrowserRouter>
            <AppShell />
          </BrowserRouter>
        </VideoPlayerProvider>
      </AudioPlayerProvider>
    </AppStateProvider>
  );
}
